if(!customElements.get('you-love-it')) {
    class YouLoveIt extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            const swiperElement = this.querySelector('[data-swiper-id="collection-list"]');
            const youLoveItSwiper = new Swiper(swiperElement, {
                slidesPerView: 3,
                loop: false,
                breakpoints: {
                    1000: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    900: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                    768: {
                        slidesPerView: 2.3,
                        spaceBetween: 10,
                    },
                    0: {
                        slidesPerView: 1.3,
                        spaceBetween: 5,
                    },
                },
            });
        }
    }
    customElements.define('you-love-it', YouLoveIt);
}